import _ from 'lodash';
import { PropsWithChildren, useContext, useState } from 'react';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';
import { CustomerInfoContext } from '../../contexts/CustomerInfoContext';
import { AcceptTcAndPpDialog } from '../dialogs/AcceptTcAndPpDialog';

export const WithAcceptedTerms = (props: PropsWithChildren<{}>) => {
  const { customerInfo } = useContext(CustomerInfoContext);
  const setShowDialog = useState<boolean>(false)[1];

  if (
    _.isNil(customerInfo) ||
    _.isEmpty(customerInfo) ||
    _.isNil(customerInfo.acceptedTcAndPp)
  )
    return <LoadingSpinner size="large" />;

  if (!customerInfo.acceptedTcAndPp)
    return <AcceptTcAndPpDialog closeDialog={() => setShowDialog(false)} />;

  return <>{props.children}</>;
};
